import React, { ReactNode } from "react";
import {
  BlueBirdTheme, Button, Loading, Typography,
} from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import useCloseReceipt from "../../useCloseReceipt";

interface ModalCloseConfirmProps {
  useCustomHook: ReturnType<typeof useCloseReceipt>;
  transferProofCard?: ReactNode;
}

const ModalCloseConfirm = ({ useCustomHook, transferProofCard }: ModalCloseConfirmProps) => {
  const {
    selectedRows,
    isCloseConfirm,
    setCloseConfirm,
    handleCloseReceipt,
  } = useCustomHook;

  const onClose = () => setCloseConfirm(false);

  return (
    <Modal
      isOpen={isCloseConfirm}
      setOpen={onClose}
      title="Konfirmasi verifikasi"
      body={<div style={{ display: "grid", gap: 24 }}>
        <Typography level={5} color={BlueBirdTheme.colors.gray.subtitle} fontWeight="medium">
          Verifikasi bon {selectedRows[0]?.trx_id_bm} dengan bukti transfer terlampir?
        </Typography>
        {transferProofCard || <Loading variant="circular" />}
      </div>}
      footer={<>
        <Button
          variant="text"
          onClick={onClose}
        >Batal</Button>
        <Button
          onClick={selectedRows[0]
            ? () => handleCloseReceipt(selectedRows[0]?.trx_id_bm)
            : undefined
          }
        >
          Verifikasi & close bon
        </Button>
      </>}
    />
  );
};

export default ModalCloseConfirm;
